import React, { memo, useCallback, useEffect } from 'react';

import { IResumeDate, IResumeFields, Languages } from 'context';
import { IExperienceValues, ResumeExperienceCardComponent } from 'organisms';

interface IResumeExperienceCardContainer {
  language: Languages;
  fields: IResumeFields;
  index: number;
  values: IExperienceValues;
  onRemoveExperience: (id: string) => void;
  onInputChange: (name: string, value: string | IResumeDate | boolean) => void;
}

export const ResumeExperienceCard = memo(
  ({
    language,
    fields,
    values,
    index,
    onInputChange,
    onRemoveExperience,
  }: IResumeExperienceCardContainer) => {
    useEffect(() => {
      if (!values.startDate.year) {
        onInputChange(`experience[${index}].endDate`, { year: '', month: '' });
      }
    }, [values.startDate.year, onInputChange, index]);

    const onToggleCurrent = useCallback(() => {
      const next = !values.isCurrent;
      onInputChange(`experience[${index}].isCurrent`, next);
      if (next) {
        onInputChange(`experience[${index}].endDate`, { year: '', month: '' });
      }
    }, [values.isCurrent, onInputChange, index]);

    return (
      <ResumeExperienceCardComponent
        language={language}
        fields={fields}
        values={values}
        index={index}
        onInputChange={onInputChange}
        isEndDateDisabled={!values.startDate.year || values.isCurrent}
        onToggleCurrent={onToggleCurrent}
        onRemoveExperience={onRemoveExperience}
      />
    );
  },
);
